import { FleetTractorUpdateModel } from "./fleet-tractor-update.model";
import { FleetTrailerUpdateModel } from "./fleet-trailer-update.mode";

export class FleetUpdateModel {
  tractor: FleetTractorUpdateModel = new FleetTractorUpdateModel();
  trailer: FleetTrailerUpdateModel = new FleetTrailerUpdateModel();
}
